import TimeAgo from "components/TimeAgo";
import { capitalize } from "util/strings";
import { BuildingPageQuery_buildingOrRedirect_building_listings_brokerInsights } from "types/pages/building/BuildingPageQuery";
import styles from "./style.module.scss";

interface IProps {
  brokerInsight: BuildingPageQuery_buildingOrRedirect_building_listings_brokerInsights;
  title?: boolean;
  style?: object;
  className?: string;
}

export default function BrokerInsight({
  brokerInsight: {
    author: { displayName, profilePicURL },
    content,
    updatedAt,
  },
  title = true,
  style = {},
  className = "",
}: IProps) {
  const name =
    displayName.indexOf("@") > 0
      ? capitalize(displayName.split("@")[0])
      : displayName;

  return (
    <section className={className} style={style}>
      {title && <h2 className={styles.title}>Broker Insight</h2>}

      <div className={styles.brokerInformation}>
        {profilePicURL && (
          <div className={styles.brokerImageContainer}>
            {/* Upgrading to next 11, disabling this to get the upgrade done */}
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img src={profilePicURL} alt="broker" className={styles.image} />
          </div>
        )}

        <div>
          <p className={styles.brokerName}>{name}</p>
          <p className={styles.lastToured}>
            Last Toured <TimeAgo date={updatedAt} />
          </p>
        </div>
      </div>

      <p className={styles.content}>{content}</p>
    </section>
  );
}
